<div class="file-upload-card">

  <div class="card-header">
    <button
      class="btn-card"
      type="button"
      (click)="eliminarArchivo()"
      *ngIf="archivoSeleccionado">
      Eliminar
    </button>
  </div>

  <hr *ngIf="archivoSeleccionado">

  <!-- ✅ El área completa es clickeable y dispara el input -->
  <label class="upload-area" for="fileInput" [class.confirmed]="archivoConfirmado">
    <div class="icon-cloud">
      <mat-icon>cloud_upload</mat-icon>
    </div>

    <p *ngIf="!archivoSeleccionado">Haz clic aquí para seleccionar un archivo</p>

    <div *ngIf="archivoSeleccionado && !archivoConfirmado">
      <p><strong>Archivo:</strong> {{ archivoSeleccionado.name }}</p>
      <small>Presiona "Crear" para confirmar</small>
    </div>

    <div *ngIf="archivoConfirmado">
      <p>✅ <strong>{{ archivoSeleccionado?.name }}</strong> listo para guardar</p>
    </div>

    <!-- ✅ Input oculto con #fileInput para ViewChild -->
    <input
      #fileInput
      id="fileInput"
      type="file"
      class="select-file"
      accept=".pdf,.docx,.doc,.txt"
      (change)="onFileSelected($event)"
      [attr.disabled]="archivoSeleccionado ? true : null"
      style="display: none;"
    />
  </label>

  <button
    class="create-button"
    type="button"
    [disabled]="!archivoSeleccionado || archivoConfirmado"
    (click)="crearArchivo()">
    {{ archivoConfirmado ? '✓ Archivo listo' : 'Crear' }}
  </button>

</div>
